(function ($) {

    // regional variables from csv
    const reqionalVariables = [
        {
            region: 'Asia Pacific',
            confirmedRatio: '0.85098512',
            confCommissionRatio: '0.1279938046',
            paidRatio: '0.9413266722'
        },
        {
            region: 'Europe',
            confirmedRatio: '0.865728959',
            confCommissionRatio: '0.2866347495',
            paidRatio: '0.9773983764'
        },
        {
            region: 'Middle East Africa',
            confirmedRatio: '0.7769962548',
            confCommissionRatio: '0.1802774854',
            paidRatio: '0.9736471953'
        },
        {
            region: 'North America',
            confirmedRatio: '0.9345133713',
            confCommissionRatio: '0.2823439355',
            paidRatio: '0.9935329022'
        },
        {
            region: 'Oceania',
            confirmedRatio: '0.8535196752',
            confCommissionRatio: '0.3685922896',
            paidRatio: '0.9751064658'
        },
        {
            region: 'South America',
            confirmedRatio: '0.8772540008',
            confCommissionRatio: '0.2298790023',
            paidRatio: '0.9422225956'
        },
    ];

    window.addEventListener("pageshow", function (event) {
        $(':input[type=number]').val('');
    });

    $(':input[type=number]').on('mousewheel', function (e) {
        $(this).blur();
    });

    $('#result').slideUp();


    function formatNumber(num) {

        const formatter = new Intl.NumberFormat('en-US', {});
        return formatter.format(num);
    }


    $('input.dollar').on('input', function (event) {
        let value = $(this).val();
        value = value.replace(/[^.\d]+/g, '');
        let num = parseFloat(value);
        if (!isNaN(num)) {
            $(this).val(formatNumber(num));
        }
    });

    var symbol = '$';
    $('#currency').on('change', function () {
        symbol = $(this).val();
        $('#adr').attr('placeholder', symbol);
        $('#tcc').attr('placeholder', symbol);
        $('.difrenceSymb').text(symbol);
    })


    $('input.dollar2').on('input', function (event) {
        let value = $(this).val();
        value = value.replace(/[^.\d]+/g, '');
        let num = parseFloat(value);
        if (!isNaN(num)) {
            $(this).val(symbol + formatNumber(num));
        }
    });

    $('input.dollar').on('keypress', function (event) {

        const keyCode = event.keyCode || event.which;
        const isDigit = keyCode >= 48 && keyCode <= 57;
        if (!isDigit) {
            event.preventDefault();
        }
    });

    $('input.dollar2').on('keypress', function (event) {

        const keyCode = event.keyCode || event.which;
        const isDigit = keyCode >= 48 && keyCode <= 57;
        if (!isDigit) {
            event.preventDefault();
        }
    });


    $('input.persent').on('input', function (e) {

        let value = $(this).val();
        let hasPercent = value.endsWith('%');
        value = value.replace(/[^\d.]/g, '');
        let num = parseFloat(value);
        if (!isNaN(num)) {
            $(this).val(num + '%');
        }
        let newCursorPosition = $(this)[0].selectionEnd;
        if (hasPercent && newCursorPosition === value.length - 1) {
            newCursorPosition--;
        }

        setCaretPosition($(this).attr('id'), ($(this).val().length - 1));

    });

    function setCaretPosition(elemId, caretPos) {
        var elem = document.getElementById(elemId);

        if (elem != null) {
            if (elem.createTextRange) {
                var range = elem.createTextRange();
                range.move('character', caretPos);
                range.select();
            } else {
                if (elem.selectionStart) {
                    elem.focus();
                    elem.setSelectionRange(caretPos, caretPos);
                } else
                    elem.focus();
            }
        }
    }

    $('input.persent').on('keypress', function (event) {

        const keyCode = event.keyCode || event.which;

        const isDigit = keyCode >= 48 && keyCode <= 57;

        if (!isDigit) {
            event.preventDefault();
        }


    });


    function calculateCommissions() {
        // Retrieve user inputs from the form
        let country = $('#country option:selected').text();
        if (country == 'Select') {
            return false;
        }
        let ab = Number(($('#ab').val()).replace(/[^\d.]/g, '')); //Annual Bookings
        let als = Number(($('#als').val()).replace(/[^\d.]/g, '')); //Average Length of Stay
        let adr = Number(($('#adr').val()).replace(/[^\d.]/g, '')); //Average Daily Rate
        let acp = Number(($('#acp').val()).replace(/[^\d.]/g, '') / 100); //Average Commission Percentage
        let tcc = Number(($('#tcc').val()).replace(/[^\d.]/g, '')); //Total Commission Collected


        // Retrieve the regional variables for the selected country
        let cr = reqionalVariables.find(item => item.region === country).confirmedRatio; //Conf Ratio
        let ccr = reqionalVariables.find(item => item.region === country).confCommissionRatio; //Conf Comm Ratio
        // Perform calculations to determine Paid Ratio and What RP Can Recover
        let paidRCurent = tcc / (ab * als * adr * acp * cr * ccr); //Paid Ratio
        let paidRRecover = Number(reqionalVariables.find(item => item.region === country).paidRatio); //Paid Ratio
        let pRResult = ab * als * adr * acp * cr * ccr * paidRRecover; //What RP Can Recover


        //Show block
        $('#result').slideDown(400);

        // Scroll to the results section
        setTimeout(function () {
            $('html, body').animate({scrollTop: $('#result').offset().top - 62}, 'slow');

        }, 400)

        let options = {
            minimumFractionDigits: 0,
            maximumFractionDigits: 0,
            useGrouping: true,
            groupingSeparator: '.',
            decimalSeparator: ',',
        };


        // Update the results section with the calculated values
        $($('#result .block-2 .item')[0]).text(country);
        $($('#result .block-3 .item')[0]).text(country);

        $($('#result .block-2 .item')[1]).text((ab) ? ab.toLocaleString('en-US', options) : 0);
        $($('#result .block-3 .item')[1]).text((ab) ? ab.toLocaleString('en-US', options) : 0);

        $($('#result .block-2 .item')[2]).text((acp) ? (acp * 100).toFixed(2) + "%" : 0);
        $($('#result .block-3 .item')[2]).text((acp) ? (acp * 100).toFixed(2) + "%" : 0);

        $($('#result .block-2 .item')[3]).text((adr) ? adr.toLocaleString('en-US', options) + symbol : 0);
        $($('#result .block-3 .item')[3]).text((adr) ? adr.toLocaleString('en-US', options) + symbol : 0);

        $($('#result .block-2 .item')[4]).text((paidRCurent) ? (paidRCurent * 100).toFixed(2) + "%" : 0);
        $($('#result .block-3 .item')[4]).text((paidRRecover) ? (paidRRecover * 100).toFixed(2) + "%" : 0);

        $($('#result .block-2 .item')[5]).text((tcc) ? (tcc.toLocaleString('en-US', options) + symbol) : 0);
        $($('#result .block-3 .item')[5]).text((pRResult) ? (pRResult.toLocaleString('en-US', options) + symbol) : 0);

        // Calculate and format the difference between What RP Can Recover and Total Commission Collected
        let difference = pRResult;
        if (pRResult - tcc <= 0) {
            $('#result .total').hide();
            $('.subtitle .text-1').hide();
            $('.subtitle .text-2').show();
        } else {
            $('#result .total').show();
            $('.subtitle .text-1').show();
            $('.subtitle .text-2').hide();
        }
        let formattedDifference = difference.toLocaleString('en-US', options);

        $('.subtitle .region').text(country);
        $('.subtitle .estcomration').text((paidRRecover * 100).toFixed(2));
        $('.subtitle .difrence').text(formattedDifference);

        console.log(formattedDifference)
        //Update the results
        $('#result .total span').text(formattedDifference + symbol);

    }

    $('.calculate_commissions_section .form  .but-wrap .bttn').click(function (e) {
        e.preventDefault();
        calculateCommissions();

    });


})(jQuery);


// WEBPACK FOOTER //
// ./src/js/custom/calculate_commissions_section.es6